<template>
  <div class="home">
    <div class="particles-container w-100">
      <vue-particles class="position-absolute w-100 h-100" color="#dedede" :particlesNumber="50"></vue-particles>
      <div
          class="col-12 col-lg-10 offset-lg-1 particles-content-container h-100 d-flex align-items-center justify-content-around">
        <div class="particles-logo-container">
          <img src="../assets/Nue5.svg" alt="">
        </div>
        <div class="slogan text-center ">
          Queremos llevar <span class="colorNue">Nue</span><span class="colorNueAlt">va</span> tecnología a todas
          partes.
        </div>
      </div>
    </div>
    <div class="container">
      <div :class="{'scroll-left':scroll1}" class="custom-card animation-scroll d-flex align-items-center">
        <div class="purple-gradient color-block z-depth-1 d-flex flex-center mr-2 mr-md-4">Origen</div>
        <div class="custom-card-content">
          Nue (misma pronunciación de new), es un proyecto que nace para luchar contra el proceso costoso, lento,
          difícil de mantener y poco adaptativo al cambio que trae consigo la forma tradicional de desarrollar software.
        </div>
      </div>
      <div :class="{'scroll-right':scroll2}" class="custom-card animation-scroll d-flex align-items-center flex-row-reverse">
        <div class="blue-gradient color-block z-depth-1 d-flex flex-center ml-2 ml-md-4">¿Por qué?</div>
        <div class="custom-card-content">
          El problema es tal, que el hecho de incluir sistemas en las pequeñas y medianas empresas se vuelve
          completamente inviable, y es así, como muchos de los procesos se siguen manejando a mano y de forma
          ineficiente, limitando a la vez, comodidades que podrían ofrecer a sus consumidores.
        </div>
      </div>
      <div :class="{'scroll-left':scroll3}" class="custom-card animation-scroll d-flex align-items-center">
        <div class="aqua-gradient color-block z-depth-1 d-flex flex-center mr-2 mr-md-4">¿Como?</div>
        <div class="custom-card-content">
          Nuestro objetivo es auxiliarnos de la agilidad y robustez que traen las Nuevas tendencias, paradigmas y
          herramientas a la hora de desarrollar software para ofrecer productos de bajo costo, pero de gran calidad,
          para poder llegar así, a cada lugar que requiera de un sistema para mejorar.
        </div>
      </div>

      <div class="powered-by">POWERED BY</div>
      <div class="pb-3 d-flex flex-wrap justify-content-around align-items-center">
        <a  :href="image.redirect" target="_blank" v-for="image in images"
           class="custom-card technology d-flex flex-center">
          <img :src="image.url" alt="">
        </a>
      </div>
    </div>

    <div class="footer-authors">
      <div class="foother-authors-title">
        Creadores
      </div>
      <div v-for="author in authors" class="d-flex justify-content-center">
        <div>
          <a :href="author.redirect" class="author-image-container">
            <img class="author-img1" :src="author.url1" alt="">
            <img class="author-img2" :src="author.url2" alt="">
          </a>
          <div class="footer-authors-container-footer">{{author.name}}</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {
        scroll1:false,
        scroll2:false,
        scroll3:false,
        images: [
          {
            url: 'https://test-storage-nue.storage.googleapis.com/technologyLogos/googleCloud.png',
            redirect: 'https://cloud.google.com/'
          }, {
            url: 'https://test-storage-nue.storage.googleapis.com/technologyLogos/Node.svg',
            redirect: 'https://nodejs.org/'
          }, {
            url: 'https://test-storage-nue.storage.googleapis.com/technologyLogos/Vue.png',
            redirect: 'https://vuejs.org/'
          }, {
            url: 'https://test-storage-nue.storage.googleapis.com/technologyLogos/flutter.png',
            redirect: 'https://flutter-es.io/'
          }, {
            url: 'https://test-storage-nue.storage.googleapis.com/technologyLogos/electron.png',
            redirect: 'https://www.electronjs.org/'
          }
        ],
        authors: [
          {
            url2: 'https://storage.googleapis.com/assets.nue.com.mx/Vicente1.jpg',
            url1: 'https://storage.googleapis.com/assets.nue.com.mx/Vicente2.jpg',
            redirect: '/vicente',
            name: 'Vicente Flores'
          }
        ]
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll(event) {
        const sizeHeight = event.path[1].innerHeight
        const factor = (sizeHeight<850) ? 240 : 350
        const offset = (sizeHeight<850) ? -80 : -130
        this.scroll1 = (event.target.scrollingElement.scrollTop < offset+factor)
        this.scroll2 = (event.target.scrollingElement.scrollTop < offset+factor*2)
        this.scroll3 = (event.target.scrollingElement.scrollTop < offset+factor*3)
      }
    }
  }
</script>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Timmana&display=swap');

  .particles-container {
    background-color: black;
    width: 100%;
    height: 100vh;
    position: relative;
    border-radius: 0 0 1rem 1rem;
  }

  .particles-content-container {
    padding-top: 5rem;
  }

  .particles-logo-container {
    width: 30%;
  }

  .particles-logo-container > img {
    max-height: 100%;
    max-width: 100%;
  }

  .slogan {
    font-size: 2.3rem;
    color: white;
    width: 27rem;
  }

  .colorNue {
    color: #22d3ff;
  }

  .color-block{
    transition: all 0.3s;
  }

  .custom-card:hover .color-block{
    transform: scale(1.2);
  }

  .colorNueAlt {
    color: #41ff81;
  }

  .home {
    background-color: #f8f8f8;
  }

  .custom-card {
    margin: 2rem 0;
  }

  .technology {
    width: 11rem;
    height: 11rem;
    margin-bottom: 1rem;
  }

  .technology:hover {
    background-color: #f8f8f8;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin-bottom: -0.5rem;
  }

  .technology img, .author-image-container img {
    max-width: 100%;
    max-height: 100%;
  }

  .custom-card-content {
    font-size: 1.1em;
    text-align: justify;
  }

  .color-block {
    height: 10rem;
    width: 10rem;
    min-width: 10rem;
    border-radius: 1rem;
    color: white;
    font-size: 2em;
  }

  .powered-by, .footer-authors {
    margin-top: 3rem;
  }

  .powered-by {
    margin-bottom: -1rem;
    text-align: center;
    font-family: 'Timmana', sans-serif;
    font-size: 2.5rem;
    color: #07d500;
  }

  .foother-authors-title {
    width: 100%;
    text-align: center;
    font-family: 'Timmana', sans-serif;
    font-size: 2.5rem;
    color: #e8f6ff;
  }

  .footer-authors{
    width: 100%;
    background: rgb(0,45,110);
    background: linear-gradient(90deg, rgb(1, 52, 125) 0%, rgb(0, 85, 160) 100%);
    border-radius: 1rem 1rem 0 0;
    padding: 2rem;
  }

  .author-image-container {
    width: 8rem;
    height: 8rem;
    border-radius: 4rem;
    overflow: hidden;
    border: solid 3px white;
    position: relative;
    margin: 0 auto;
    display: block;
  }

  .author-image-container img {
    position: absolute;
  }

  .footer-authors-container-footer {
    text-align: center;
    color: white;
    font-size: 1.3em;
    margin: 0.25rem;
  }

  .author-image-container:hover img:last-child {
    visibility: hidden;
  }

  .scroll-left{
    margin-left: -12rem;
    margin-right: 12rem;
    opacity: 0;
  }

  .scroll-right{
    margin-left: 12rem;
    margin-right: -12rem;
    opacity: 0;
  }

  .animation-scroll{
    transition: 0.8s;

  }

  @media (min-width: 992px) {
    .color-block {
      height: 8rem;
      width: 8rem;
      min-width: 8rem;
      font-size: 1.8rem;
    }

    .custom-card-content {
      font-size: 1.2em;
      text-align: justify;
    }
  }

  @media (max-width: 768px) {
    .particles-content-container {
      flex-direction: column;
      justify-content: start !important;
    }

    .particles-logo-container {
      width: 40%;
      padding-top: 3rem;
      padding-bottom: 1rem;
    }

    .slogan {
      font-size: 1.5rem;
      width: 90%;
      max-width: 20rem;
    }

  }

  @media (max-width: 576px) {
    .particles-logo-container {
      width: 60%;
      padding-top: 3rem;
      padding-bottom: 2rem;
    }

    .technology {
      width: 9rem;
      height: 9rem;
      padding: 1rem;
      margin-bottom: 1.5rem;
    }

    .color-block {
      height: 8rem;
      width: 8rem;
      min-width: 8rem;
    }

    .custom-card {
      flex-direction: column !important;
    }

    .custom-card .color-block {
      width: 100%;
      margin-bottom: 1rem;
    }


  }

</style>
